import { FavouritesAds } from './ui/FavouritesAds'
export default FavouritesAds